import React, { useEffect,useState } from "react";
import axios from "axios";
import '../order/OrderList.css'
import { Link } from "react-router-dom"; // File untuk styling
import Pagination from 'react-bootstrap/Pagination';
import { useNavigate } from 'react-router-dom';


function DataUploadList() {
    const [tokenNow, setTokenNow] = useState('');
    const navigate = useNavigate();
    const [error, setError] = useState("");

    const [dataUploads, setDataUploads] = useState([]);
    const [selectedOption, setSelectedOption] = useState('keyUploadDate');

    // order date
    const [selectedUploadDateFrom, setSelectedUploadDateFrom] = useState('');
    const [inputUploadDateFrom, setInputUploadDateFrom] = useState('');
    const [selectedUploadDateUntil, setsetSelectedUploadDateUntil] = useState('');
    const [inputUploadDateUntil, setInputUploadDateUntil] = useState('');

    // File Name
    const [selectedFileName, setSelectedFileName] = useState('');
    const [inputFileName, setInputFileName] = useState('');

    // status
    const [selectedStatus, setSelectedStatus] = useState('');
    const [inputStatus, setInputStatus] = useState('');

    const resource = 'operation/data-upload-list'

    useEffect(() => {
      const storedToken = localStorage.getItem('token');
        setTokenNow(storedToken);

        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();

        defaultPage();
      }, []);

      function defaultPage(){
        // Mendapatkan tanggal hari ini
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const todayFormatted = tomorrow.toISOString().split('T')[0];

        // Mendapatkan tanggal 30 hari sebelum hari ini
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 30);
        const pastDateFormatted = pastDate.toISOString().split('T')[0];

        setInputUploadDateFrom(pastDateFormatted)
        setInputUploadDateUntil(todayFormatted)
        loadDataUploadList(selectedOption,pastDateFormatted,todayFormatted);
        
      }

    useEffect(() => { 
        if (selectedStatus !== '') {
            loadDataUploadList(selectedOption, selectedStatus);
          } else if (selectedFileName !== '') {
            loadDataUploadList(selectedOption, selectedFileName);
          } else if (selectedUploadDateFrom !== '' && selectedUploadDateUntil !== '') {
            loadDataUploadList(selectedOption,selectedUploadDateFrom,selectedUploadDateUntil);
          }
    }, [selectedUploadDateFrom,selectedUploadDateUntil,selectedStatus, selectedFileName]);
  
    const resetFiltersExcept = (filterType) => {
        if (filterType !== 'status') {
          setSelectedStatus('');
          setInputStatus('');
        }
        if (filterType !== 'fileName') {
          setSelectedFileName('');
          setInputFileName('');
        }   
        if (filterType !== 'uploadDate') {
          setSelectedUploadDateFrom('');
          setInputUploadDateFrom('');
          setsetSelectedUploadDateUntil('');
          setInputUploadDateUntil('');
        }
      };
    
    const loadDataUploadList = async (key,value1,value2) => {
        try {     
          const result = await axios.get(`https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/data-upload-list?param1=${key}&param2=${value1}&param3=${value2}`);
          const data = result.data;
          setDataUploads(data);    
        } catch (error) {
          console.error("Error loading order list:", error);
        }
      };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
  
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
      };    

      const handleSelectChange = (event) => {
        setCurrentPage(1)
        setSelectedOption(event.target.value);
      };  

    //   order date
      const handleUploadDateFromChange = (event) => {
        setCurrentPage(1)
        setInputUploadDateFrom(event.target.value);
      };   
      const handleUploadDateUntilChange = (event) => {
        setCurrentPage(1)
        setInputUploadDateUntil(event.target.value);
      };

      // status
      const handleStatusChange = (event) => {
        setCurrentPage(1)
        setInputStatus(event.target.value);
      };

      // File Name
      const handleFileNameChange = (event) => {
        setCurrentPage(1)
        setInputFileName(event.target.value);
      };

      const handleSubmitStatus = (event) => {
        event.preventDefault();
        resetFiltersExcept('status')
        setSelectedStatus(inputStatus);
      };
    
      const handleSubmitFileName = (event) => {
        event.preventDefault();
        resetFiltersExcept('fileName');
        setSelectedFileName(inputFileName);
      };
    
      const handleSubmitUploadDate = (event) => {
        event.preventDefault();
        resetFiltersExcept('uploadDate');
        setSelectedUploadDateFrom(inputUploadDateFrom);
        setsetSelectedUploadDateUntil(inputUploadDateUntil);
      };

      //pagination
      const [currentPage, setCurrentPage] = useState(1);
      const ordersPerPage = 25;
    
      // Get current orders
      const indexOfLastOrder = currentPage * ordersPerPage;
      const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
      const currentDataUploads = dataUploads.slice(indexOfFirstOrder, indexOfLastOrder);
    
      // Change page
      const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      // Generate pagination items
      const pageNumbers = [];
      for (let i = 1; i <= Math.ceil(dataUploads.length / ordersPerPage); i++) {
        pageNumbers.push(i);
      }

      const renderPaginationItems = () => {
        const paginationItems = [];
        let ellipsisShown = false;
    
        for (let i = 1; i <= pageNumbers.length; i++) {
          if (i === 1 || i === pageNumbers.length || (i >= currentPage - 2 && i <= currentPage + 2)) {
            paginationItems.push(
              <Pagination.Item
                key={i}
                active={i === currentPage}
                onClick={() => paginate(i)}
              >
                {i}
              </Pagination.Item>
            );
            ellipsisShown = false;
          } else if (!ellipsisShown) {
            paginationItems.push(<Pagination.Ellipsis key={`ellipsis-${i}`} />);
            ellipsisShown = true;
          }
        }
    
        return paginationItems;
      };

    return (
        <div className="container-order-list">
          {/*<update-code */}
          <input type="hidden" name="token" value={tokenNow} /> {/* Hidden token field */}
            {/* update-code>*/}
            <h1>Cross Connect Data Upload List</h1>
                <div className="title-order-input">   
                    <h6>Fulfill filter information to show Data Upload.</h6>   
                    {error && <p className="error-message">{error}</p>}            
                    <h5>Filter</h5>
                </div>      
                <form>
                <div className="textbox-order-list">
                  <label htmlFor="comboBox">Key</label>
                  <select id="comboBox" name="options" onChange={handleSelectChange}>
                    <option value="keyUploadDate">Upload Date</option>\
                    <option value="keyFileName">File Name</option>
                    <option value="keyStatus">Status</option>                                 
                  </select>
                </div>               
            </form>
            {selectedOption === 'keyUploadDate' && (
                <form onSubmit={handleSubmitUploadDate}>
                    <div className="textbox-order-list-date">
                        <label htmlFor="orderDate">Register Date</label>
                            <input type="date" 
                                className="dateFilter1"
                                id="orderDate" 
                                value={inputUploadDateFrom}
                                onChange={handleUploadDateFromChange}/>
                            <input type="date" 
                                className="dateFilter2"
                                id="orderDate" 
                                value={inputUploadDateUntil}
                                onChange={handleUploadDateUntilChange}/>                                           
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}     
            {selectedOption === 'keyFileName' && (
                <form onSubmit={handleSubmitFileName}>
                    <div className="textbox-order-list">
                        <label htmlFor="fileName">File Name</label>
                        <input type="text" 
                            placeholder="File Name" 
                            value={inputFileName}
                            onChange={handleFileNameChange}/>          
                    </div>
                    <input type="submit" className="btn-submit-order-list" value="Search" />
                </form>
                )}
            {selectedOption === 'keyStatus' && (
                <form onSubmit={handleSubmitStatus}>
                    <div className="value-status">
                        <div className="textbox-order-list">
                            <label htmlFor="comboBox">Status</label>
                            <select id="comboBox" name="options" value={inputStatus} onChange={handleStatusChange}>
                                <option hidden>Select Upload Status</option>
                                <option key='UPLOADED' value='UPLOADED'>UPLOADED</option>
                                <option key='COMPLETED' value='COMPLETED'>COMPLETED</option>
                            </select>                         
                        </div>
                        <input type="submit" className="btn-submit-order-list" value="Search" />
                    </div>
                </form>
            )}           
      <table className="table table-bordered">
        <thead>
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Upload Date</th>
            <th scope="col">File Name</th>
            <th scope="col">Description</th>
            <th scope="col">Status</th>
            <th scope="col" colSpan="2">Action</th>
          </tr>
        </thead>
        <tbody>
        {currentDataUploads.map((data) => (
            <tr key={data.id}>
              <td>{data.id}</td>
              <td>{formatDate(data.upload_date)}</td>
              <td>{data.file_name}</td>
              <td>{data.description}</td>
              <td>{data.upload_status}</td>
              <td className="icon-center">
                <Link to={`/download?id=${data.id}`}>
                  <i className="bi bi-filetype-csv" title="Download"></i>
                </Link>
              </td>
              <td className="icon-center">
                <Link to={`/summary?id=${data.id}`} >
                  <i className="bi bi-aspect-ratio-fill" title="Summary"></i>
                </Link>
              </td>
            </tr>
        ))}
      </tbody>

      </table>

      <Pagination>
        <Pagination.First onClick={() => paginate(1)} />
        <Pagination.Prev
          onClick={() => paginate(currentPage > 1 ? currentPage - 1 : 1)}
        />
        {renderPaginationItems()}
        <Pagination.Next
          onClick={() =>
            paginate(
              currentPage < pageNumbers.length ? currentPage + 1 : pageNumbers.length
            )
          }
        />
        <Pagination.Last onClick={() => paginate(pageNumbers.length)} />
      </Pagination>   
        </div>
    );
}

export default DataUploadList;
